import React from 'react'
import ProductCardSmall from '../components/product-card/small';

export default function CreateProductCardSmall(itemData) {
    return (
      <ProductCardSmall
        name={itemData.name}
        coverImage={itemData.coverImage}
        mrp={itemData.mrp}
        sellingPrice={itemData.sellingPrice}
        ratting={itemData.ratting}
        rattingPerson={itemData.rattingPerson}
        stock={itemData.stock}
        unit={itemData.unit}
        packaged={itemData.packaged}
        company={itemData.company}
        veg={itemData.veg}
        id={itemData._id}
      />
    );
  }